<template>
  <div class="register-wrap">
    <div class="mobile-screen" v-if="platform == 'mobile'">
      <div class="tip">
        短信验证码已发送至 <span>{{ mobilePhone }}</span>
      </div>
      <div class="input-group">
        <div class="left">
          <img src="../../static/img/register/code.png" />
        </div>
        <div class="middle">
          <input
            type="tel"
            placeholder="验证码"
            v-model.trim="postData.verify_code"
            maxlength="6"
          />
        </div>
        <div class="right">
          <button v-if="inputting">{{ second }}s</button>
          <button class="active" v-if="!inputting" @click="verifyCodeGet">
            获取验证码
          </button>
        </div>
      </div>
      <div class="input-button">
        <button @click="beforeRegister" :disabled="submitting || !formValid">
          确定
        </button>
      </div>

      <div class="fill-space"></div>

      <div class="register-bottom">
        <label class="checkbox">
          <img
            src="../../static/img/register/agree.png"
          />点击确定代表你已阅读并同意
        </label>

        <div class="policy">
          <router-link :to="{ name: 'policy' }">熊猫签证用户协议</router-link>
        </div>
      </div>
    </div>

    <div class="pc-screen" v-if="platform == 'pc'">
      <div class="main">
        <div class="header"></div>
        <div class="tip">
          短信验证码已发送至<br /><span>{{ mobilePhone }}</span>
        </div>
        <div class="input-group">
          <div class="middle">
            <input
              type="tel"
              placeholder="验证码"
              v-model.trim="postData.verify_code"
              maxlength="6"
            />
          </div>
          <div class="right">
            <button v-if="inputting">{{ second }}s</button>
            <button class="active" v-if="!inputting" @click="verifyCodeGet">
              获取验证码
            </button>
          </div>
        </div>
        <div class="input-button">
          <button @click="beforeRegister" :disabled="submitting || !formValid">
            确定
          </button>
        </div>
      </div>

      <div class="footer">
        粤ICP备15048723号-2 Copyright© 熊猫签证 2016-2017，版权所有
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';
import InviteService from '../services/inviteService.js';
import toast from '../services/toast.js';

export default {
  data() {
    return {
      platform: utils.getPlatform(),
      inviteService: new InviteService(this.$http),
      mobilePhone: this.$route.params.mobilePhone, // 从邀请过来
      userId: parseInt(this.$route.params.userId), // 从邀请过来
      companyName: this.$route.query.companyName, // 从企业优惠券跳转过来就有这个属性
      maxReduce: this.$route.query.maxReduce, // 从普通优惠券过来就有这个属性
      second: 60,
      postData: {
        verify_code: '',
      },
      inputting: true,
      submitting: false,
    };
  },

  computed: {
    formValid() {
      const vcode = this.postData.verify_code;
      if (!vcode) {
        return false;
      }
      return true;
    },
  },

  methods: {
    countStart() {
      this.interval = setInterval(() => {
        this.second -= 1;

        if (this.second <= 0) {
          this.inputting = false;
          this.second = 60;
          clearInterval(this.interval);
          this.interval = null;
        }
      }, 1000);
    },

    verifyCodeGet() {
      this.inputting = true;

      this.inviteService
        .verifyCodeGet(this.mobilePhone)
        .then((res) => {
          const resData = res.data;

          if (resData.ret === 0) {
            this.countStart();
            toast.show('手机验证码已发送', 2000);
          } else {
            this.inputting = false;
            toast.show(resData.msg);
          }
        })
        .catch(() => {
          this.inputting = false;
          toast.show('网络异常，请稍后再试');
        });
    },

    beforeRegister() {
      MtaH5.clickStat('register_comfirm');
      if (this.formValid) {
        // 如果从优惠券跳过来
        if (this.userId === -1) {
          this.addUserAccount();
        } else {
          this.addUserRealtion();
        }
      }
    },

    // 添加加账号
    addUserAccount() {
      const postData = Object.assign({}, this.postData, {
        mobile_phone: this.mobilePhone,
      });
      this.inviteService.addAccount(postData).then((res) => {
        const resData = res.data;

        if (resData.ret === 0) {
          this.$router.replace({
            name: 'registerSuccess',
            query: this.$route.query,
            // query: {
            //   companyName: this.companyName, // 公司优惠券（都传递，没有那边就回去不到而已）
            //   maxReduce: this.maxReduce, // 普通优惠券（都传递，没有那边就回去不到而已）
            // },
          });
        } else {
          toast.show(resData.msg);
        }
      });
    },

    // 添加账号关系，其实也是注册，只是同时简历关系，邀请的时候到这里
    addUserRealtion() {
      const postData = Object.assign({}, this.postData, {
        user_account_id: this.userId,
        mobile_phone: this.mobilePhone,
      });

      this.inviteService.register(postData).then((res) => {
        const resData = res.data;

        if (resData.ret === 0) {
          this.$router.replace({
            name: 'registerSuccess',
            query: { ...this.$route.params, invite: 1 },
            // query: {
            //   maxReduce: data.max_reduce / 100,
            //   invite: 1, // 这个属性标记到下个页面，说明是邀请好友过来的
            // },
          });
        } else {
          toast.show(resData.msg);
        }
      });
    },
  },

  created() {
    utils.setTitle('注册领取新人大礼');

    if (!this.mobilePhone || !this.userId) {
      return toast.show('参数错误');
    }

    // 这个userId为-1代表是从普通优惠券领取和企业优惠券领取那边过来的
    // 而从邀请好友那里过来的就是真正的用户id
    if (this.userId === -1) {
      document.title = '注册熊猫签证';

      // 进来就要倒计时，因为那边跳转到这个页面之前就已经发送了验证码
      this.countStart();
    } else {
      // 邀请进来的才立即发送
      this.verifyCodeGet();
    }
  },

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>

<style lang="less" scoped>
@import '../styles/theme.less';

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.register-wrap {
  height: 100%;
  letter-spacing: 0.0015rem;
  background-color: white;
}

.mobile-screen {
  padding: 0.25rem 0.1rem;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .tip {
    font-size: 0.14rem;
    line-height: 0.18rem;
    color: #444444;
    margin-bottom: 0.18rem;

    span {
      font-weight: 600;
      font-size: 0.18rem;
    }
  }

  .input-group {
    height: 0.5rem;
    display: flex;
    align-items: center;
    position: relative;

    img {
      width: 0.18rem;
      height: 0.18rem;
    }

    .left {
      padding: 0 0.14rem 0 0.06rem;
    }

    .middle {
      flex: 1;
      padding-right: 0.1rem;
    }

    input {
      border: none;
      color: #444;
      font-size: 0.15rem;
      padding: 0.1rem 0;
      width: 100%;
    }

    button {
      border: 1px solid @border-dark;
      border-radius: 0.04rem;
      background-color: white;
      font-size: 0.12rem;
      color: #aaa;
      height: 0.3rem;
      padding: 0 0.2rem;
      min-width: 0.8rem;

      &.active {
        color: @red;
        border-color: @red;
      }

      &.active:active {
        background-color: #fafafa;
      }
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      border-bottom: 1px solid @border;
      bottom: 0;
      right: 0;
      left: 0.38rem;
      transform: translateY(0.5);
    }
  }

  .input-button {
    margin-top: 0.2rem;

    button {
      display: block;
      width: 100%;
      height: 0.45rem;
      font-size: 0.17rem;
      color: white;
      background-color: @red;
      border: none;
      border-radius: 0.04rem;

      &[disabled] {
        color: rgba(255, 255, 255, 0.9);
        background-color: lighten(@red, 10%);
      }

      &:active {
        background-color: darken(@red, 5%);
      }
    }
  }

  .fill-space {
    flex: 1;
  }

  .register-bottom {
    text-align: center;
    margin-top: 0.2rem;
    .checkbox {
      font-size: 0.12rem;
      color: #cfcfcf;

      img {
        width: 0.12rem;
        position: relative;
        top: 0.02rem;
        margin-right: 0.03rem;
      }
    }

    .policy {
      margin-top: 0.06rem;

      a {
        font-size: 0.12rem;
        color: #aaa;
      }
    }
  }
}

.pc-screen {
  background-color: #f3f4f6;
  min-height: 100%;
  padding-top: 132px;
  position: relative;
  padding-bottom: 80px;

  .main {
    width: 750px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: white;
    overflow: hidden;
    padding-bottom: 170px;
  }

  .footer {
    font-size: 0.12rem;
    text-align: center;
    color: #aaa;
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
  }

  .header {
    background: @red url(../../static/img/invite/banner-pc.jpg) no-repeat center
      bottom;
    background-size: contain;
    position: relative;
    height: 140px;
  }

  .tip {
    text-align: center;
    font-size: 0.14rem;
    line-height: 0.18rem;
    color: #333;
    margin-top: 40px;
    margin-bottom: 40px;

    span {
      font-weight: 600;
      font-size: 22px;
      display: inline-block;
      margin-top: 10px;
    }
  }

  .input-group {
    height: 0.5rem;
    display: flex;
    align-items: center;
    position: relative;
    width: 360px;
    margin: 0 auto;
    border: 1px solid #cfcfcf;
    border-radius: 6px;

    & + .input-group {
      margin-top: 30px;
    }

    .middle {
      flex: 1;
      padding: 0 0.1rem;
    }

    .right {
      padding-right: 0.1rem;
    }

    input {
      border: none;
      color: #444;
      font-size: 16px;
      width: 100%;
      padding: 0.1rem 0;
    }

    button {
      border: 1px solid @border-dark;
      border-radius: 4rem;
      background-color: white;
      font-size: 0.12rem;
      color: #aaa;
      height: 0.3rem;
      padding: 0 0.15rem;
      min-width: 0.8rem;

      &.active {
        color: @red;
        border-color: @red;
      }

      &.active:active {
        background-color: #fafafa;
      }
    }
  }

  .input-button {
    margin-top: 30px;

    button {
      display: block;
      width: 360px;
      height: 0.45rem;
      font-size: 0.17rem;
      color: white;
      background-color: @red;
      border: none;
      border-radius: 0.04rem;
      margin: 0 auto;

      &[disabled] {
        color: rgba(255, 255, 255, 0.9);
        background-color: lighten(@red, 10%);
      }

      &:active {
        background-color: darken(@red, 5%);
      }
    }
  }

  .register-bottom {
    position: absolute;
    bottom: 0.34rem;
    left: 0;
    right: 0;
    text-align: center;

    .checkbox {
      font-size: 0.12rem;
      color: #cfcfcf;

      img {
        width: 0.12rem;
        position: relative;
        top: 0.02rem;
        margin-right: 0.03rem;
      }
    }

    .policy {
      margin-top: 0.06rem;

      a {
        font-size: 0.12rem;
        color: #aaa;
      }
    }
  }
}
</style>
